export const SamplePlayerActions = Object.freeze({
  // sample player commands
  PLAY: 'SAMPLE_PLAY',
  ERROR: 'SAMPLE_ERROR',
  PLAYING: 'SAMPLE_PLAYING',
  PAUSED: 'SAMPLE_PAUSED',
  ENDED: 'SAMPLE_ENDED',
  STOPPED: 'SAMPLE_STOPPED',
  SHOULD_RESUME_TRACK: 'SAMPLE_SHOULD_RESUME_TRACK',
  PLAY_SAMPLES: 'SAMPLE_PLAY_SAMPLES',
  STOP_SAMPLES: 'SAMPLE_STOP_SAMPLES',
});
